import React from 'react';
import { FolderInput, Library, UserCheck } from 'lucide-react';
import { useOfficeContext } from '../../hooks/useOfficeContext';

const Card = ({ title, subtitle, icon: Icon, onClick, disabled }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="w-full text-left bg-white border border-gray-200 rounded-xl p-3 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-[#C5A059]/40"
  >
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-lg bg-gray-50 border border-gray-200 flex items-center justify-center text-gray-700">
        <Icon className="w-5 h-5" />
      </div>
      <div className="min-w-0">
        <div className="text-xs font-bold text-gray-900 truncate">{title}</div>
        <div className="text-[10px] text-gray-500 truncate">{subtitle}</div>
      </div>
    </div>
  </button>
);

export default function BridgeHome({ onNavigate }) {
  const { isWord } = useOfficeContext();
  const status = isWord ? 'word' : 'web';

  const statusBadge = {
    word: { label: '🟢 Conectado ao Word', bg: 'bg-green-100 text-green-700' },
    web: { label: '🟠 Modo Web (Sem Vínculo)', bg: 'bg-yellow-100 text-yellow-700' }
  };

  const current = statusBadge[status] || statusBadge.web;

  return (
    <div className="space-y-2">
      <div className={`text-xs font-bold px-3 py-2 rounded-lg ${current.bg} ${current.text}`}>
        {current.label}
      </div>
      <Card
        title="Bibliotecário"
        subtitle="Buscar e citar (ABNT/APA)"
        icon={Library}
        onClick={() => onNavigate && onNavigate('/bridge/zotero')}
      />
      <Card
        title="Organizador"
        subtitle="Renomear PDFs e baixar ZIP"
        icon={FolderInput}
        onClick={() => onNavigate && onNavigate('/bridge/file-hub')}
      />
      <Card
        title="Copiar Cliente"
        subtitle="Qualificação completa"
        icon={UserCheck}
        onClick={() => onNavigate && onNavigate('/bridge/clients')}
      />
    </div>
  );
}